import Vue from 'vue'
import VueI18n from 'vue-i18n'
import cookies from 'vue-cookies'
import en from './languages/en.json'
import de from './languages/de.json'
import fr from './languages/fr.json'
import it from './languages/it.json'

Vue.use(VueI18n)

const messages = {
   en,
   de,
   fr,
   it
}

/**
 * Handles the translation of the app. If a cookie is already definded (by the users choice) then that gets used.
 * If none is present it chooses the navigator.language for a default language (Language set in chrome or System language
 * when using as a PWA). Fallback language is "en".
 */
const i18n = new VueI18n({
   locale: cookies.get('locale') || navigator.language.substr(0, 2), // set locale
   fallbackLocale: 'en', // set fallback locale
   messages // set locale messages
})

export default i18n
